import { useQuery } from '@tanstack/react-query';

import { customerNotificationsQueryOptions } from '@/api/customer/customerNotificationsQuery';
import { useHasSession } from '@/hooks/auth/useHasSession';

import type { UseCustomerNotificationsQueryOptions } from './types';

export const useCustomerNotificationsQuery = ({
  customerId,
  enabled = true,
  ...options
}: UseCustomerNotificationsQueryOptions) => {
  const hasSession = useHasSession();

  return useQuery({
    ...customerNotificationsQueryOptions(customerId),
    ...options,
    enabled: enabled && !!customerId && hasSession,
  });
};
